export const ru = {
    access: 'права доступа',
    id: 'id',
    'product-name': 'название продукта'
};
